const generateLocalizedRoute = (route, languageRegionCode = 'en-US') => {
  if (languageRegionCode === 'en-US') {
    return route;
  }

  const shortRegionCode = languageRegionCode.split('-')[0];
  return `/${shortRegionCode}${route}`;
};

const pushHistory = (route, history, languageRegionCode = 'en-US') => {
  const localizedRoute = generateLocalizedRoute(route, languageRegionCode);
  history.push(localizedRoute);
};

// pathname matching with locale
const localizedRouteIncludes = (pathname, routes = [], languageRegionCode = 'en-US') => {
  let path;

  if (languageRegionCode === 'en-US') {
    path = pathname;
  } else {
    const shortRegionCode = languageRegionCode.split('-')[0];
    path = pathname.replace(`/${shortRegionCode}`, '');
  }

  return routes.includes(path);
};

export { pushHistory, generateLocalizedRoute, localizedRouteIncludes };
